import * as caUtil from "@callApi";

const callApi = caUtil.callApi;
import WindowFunc from "./window";

export const checkJoin = () => {
  if (window.emJoinStatus) {
    // return window.emJoinStatus;
    return new Promise((rs, rj) => {
      rs(window.emJoinStatus);
    });
  } else {
    return callApi("/api/ec/dev/app/checkJoin", "GET", {}).then(res => {
      if (res.status == true) {
        window.emJoinStatus = res;
        return window.emJoinStatus;
      } else {
        window.emJoinStatus = {
          status: false,
          joinStatus: false,
          emSwitch: "0",
          shareSwitch: "0",
          webSwitch: "0",
          wxWorkShareSwitch: "0",
          dingTalkShareSwitch: "0"
        };
        return window.emJoinStatus;
      }
    });
  }
};
checkJoin();

window.em_checkJoin = checkJoin;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/emTools.js